import { basePath, apiVersion,basePathCantant,ip } from "./config";
import {getRefreshTokenApi,getPublicIP,getAccessTokenApi} from "../api/auth";
import {notification,message} from "antd";

export function getContarError(name,messager) {
    
    var status;
    var urlFetch='';
    var messag='';
    var url='';

    if (process.env.REACT_APP_API_URL === 'localhost') {
      url = `http://${ip}:3004/contarError`;
    }else{
      url = `https://${ip}:3004/contarError`;
    }
  
      const params = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          // Authorization: "Bearer " + accessToken,
          // refreshToken: "Bearer " + refreshToken,
           functionname:name,
           message:messager,
           ippublica:getPublicIP()
        },
      };
      
        return fetch(url, params)
      .then((response) => {
        status=response.status;
        urlFetch=response.url;
        if (process.env.REACT_APP_API_URL === 'localhost') {
          urlFetch=urlFetch.replace(`http://${ip}:3004/`,'')
        }else{
          urlFetch=urlFetch.replace(`https://${ip}:3004/`,'')
        }
        return response.json();
      })
      .then((result) => {
        
        if(status!==200){
          
            messag=result.message
            notification["error"]({
              message: `Error ${status} in function: ${urlFetch}`,
              description:messag
            });
            // getContarError(urlFetch,messag);
          
        }
        return result;
      })
      .catch((err) => {
        return err.message;
      });
  }


export function getExcelQuentin(data) {
  const url =basePathCantant;
  var status;
  var urlFetch='';
  var messag='';

  const params = {
    method: "POST",
    body: JSON.stringify({
      DATA: data,
    }),
    headers: {
      "Content-Type": "application/json",
      //Authorization: token,
    },
  };

  return fetch(url, params)
  .then((response) => {
    status=response.status;
    urlFetch=response.url;
    urlFetch=urlFetch.replace(`${basePath}/${apiVersion}/`,'')
    return response.json();
  })
  .then((result) => {
    if(status!==200){
      messag=result.message
      notification["error"]({
        message: `Error ${status} in function: ${urlFetch}`,
        description:messag
      });
      getContarError(urlFetch,messag);
    }
    return result;
  })
  .catch((err) => {
    return err.message;
  });
}

export function getCookieIShare(code, idp) {
  //console.log(idp);
  //Accedo al endpoint con su url
  var status;
  var urlFetch='';
  var messag='';
  const url =
    `${basePath}/${apiVersion}/i4trust/idpAccessAuthorised/userInfo?code=` +
    code;
  //console.log("Entramos");
  const params = {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      idp: idp,
    },
  };
  return fetch(url, params)
    .then((response) => {
      status=response.status;
      urlFetch=response.url;
      urlFetch=urlFetch.replace(`${basePath}/${apiVersion}/`,'')
      return response.json();
    })
    .then((result) => {
      if(status!==200){
      
          messag=result.message
          notification["error"]({
            message: `Error ${status} in function: ${urlFetch}`,
            description:messag
          });
          getContarError(urlFetch,messag);
        
      }
      return result.message;
    })
    .catch((err) => {
      return err.message;
    });
}

export function getUserRol(token) {
  const url = `${basePath}/${apiVersion}/user-rol`;
  const refreshToken = getRefreshTokenApi();
  var status;
  var urlFetch='';
  var messag='';

  const params = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
      refreshToken: "Bearer " + refreshToken,
      functionname:'getUserRol',
      ippublica:getPublicIP()
    },
  };

  return fetch(url, params)
    .then((response) => {
      status=response.status;
      urlFetch=response.url;
      urlFetch=urlFetch.replace(`${basePath}/${apiVersion}/`,'')
      return response.json();
    })
    .then((result) => {
      if(status!==200){
       
          messag=result.message
          notification["error"]({
            message: `Error ${status} in function: ${urlFetch}`,
            description:messag
          });
          getContarError(urlFetch,messag);
        
      }
      return result.rol;
    })
    .catch((err) => {
      return err.message;
    });
}

export function uploadAvatarApi(token, avatar, name,url1) {
  const url = `${basePath}/${apiVersion}/${url1}/${name}`;
  const refreshToken = getRefreshTokenApi();
  var status;
  var urlFetch='';
  var messag='';

  const formData = new FormData();
  formData.append("avatar", avatar);

  const params = {
    method: "POST",
    body: formData,
    headers: {
      Authorization: "Bearer " + token,
      refreshToken: "Bearer " + refreshToken,
      functionname:'uploadAvatarApi',
      ippublica:getPublicIP()
    },
  };
  console.log('avatar',avatar)

  return fetch(url, params)
    .then((response) => {
      status=response.status;
      urlFetch=response.url;
      urlFetch=urlFetch.replace(`${basePath}/${apiVersion}/`,'')
      return response.json();
    })
    .then((result) => {
      if(status!==200){
          messag=result.message
          notification["error"]({
            message: `Error ${status} in function: ${urlFetch}`,
            description:messag
          });
          getContarError(urlFetch,messag);
        
      }
      return result;
    })
    .catch((err) => {
      return err.message;
    });
}

export function getAvatarApi(avatarName) {
  const url = `${basePath}/${apiVersion}/get-avatar/${avatarName}`;
  var status;
  var urlFetch='';
  var messag='';

  return fetch(url)
    .then((response) => {
      status=response.status;
      urlFetch=response.url;
      urlFetch=urlFetch.replace(`${basePath}/${apiVersion}/`,'')
      return response.url;
    })
    .then((result) => {
      if(status!==200){
       
          messag=result.message
          notification["error"]({
            message: `Error ${status} in function: ${urlFetch}`,
            description:messag
          });
          getContarError(urlFetch,messag);
        
      }
      return urlFetch;
    })
    .catch((err) => {
      return err.message;
    });
}

export async function Keyrock(idp) {
  /*//console.log("Keyrock");
 //console.log(idp); */
  const url = `${basePath}/${apiVersion}/i4trust/userInfo2`;
  var status;
  var urlFetch='';
  var messag='';

  const params = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      idp: idp,
    },
    body: JSON.stringify({}),
  };

  return fetch(url, params)
    .then((response) => {
      status=response.status;
      urlFetch=response.url;
      urlFetch=urlFetch.replace(`${basePath}/${apiVersion}/`,'')
      return response.json();
    })
    .then((result) => {
      if(status!==200){
       
          messag=result.message
          notification["error"]({
            message: `Error ${status} in function: ${urlFetch}`,
            description:messag
          });
          getContarError(urlFetch,messag);
        
      }
      return result.message;
    })
    .catch((err) => {
      return err.message;
    });
}


export function deleteHD(data) {
  const url = `${basePath}/${apiVersion}/delete-hd`;
  const refreshToken = getRefreshTokenApi();
  const token = getAccessTokenApi();
  var status;
  var urlFetch='';
  var messag='';
  const params = {
    method: "DELETE",
    body: JSON.stringify({
      data: data,
    }),
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
      refreshToken: "Bearer " + refreshToken,
      functionname:'deleteHD',
      ippublica:getPublicIP()
    },
  };
//  console.log(data);

  return fetch(url, params)
    .then((response) => {
      // console.log('jiji: ',response)
      status=response.status;
      urlFetch=response.url;
      urlFetch=urlFetch.replace(`${basePath}/${apiVersion}/`,'')
      return response.json();
    })
    .then((result) => {
      // console.log('jijis: ',result)
      if(status!==200){
          messag=result.message
          notification["error"]({
            message: `Error ${status} in function: ${urlFetch}`,
            description:messag
          });
          getContarError(urlFetch,messag);
      }
      if (result.user) {
        
        return { ok: true, message: "Usuario creado correctamente" };
      }
      return { ok: false, message: result.message };
    })
    .catch((err) => {
      return { ok: false, message: err.message };
    });
}


export function getOutputSimulationFile(token, id_simulation) {
  const url = `${basePath}/${apiVersion}/get-output-simulacion/${id_simulation}`;
  const refreshToken = getRefreshTokenApi();
  var status;
  var urlFetch='';
  //console.log(url);
  const params = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
      refreshToken: "Bearer " + refreshToken,
      functionname:'getOutputSimulationFile',
      ippublica:getPublicIP()
    },
  };

  
  return fetch(url, params)
  .then((response) => {
    status=response.status;
    urlFetch=response.url;
    urlFetch=urlFetch.replace(`${basePath}/${apiVersion}/`,'')
    return response.blob()})
    .then((blobby) => {
      if(status!==200){
          notification["error"]({
            message: `Error ${status} in function: ${urlFetch}`,
          });
          getContarError(urlFetch,`Error ${status} in function: ${urlFetch}`);
        
      }
      let anchor = document.createElement("a");
      document.body.appendChild(anchor);
      let objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = `${id_simulation}`;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    })
    .catch((err) => {
      return err.message;
    });
}

export async function downloadFilefromIta(token, id_simulation) {
  const url = `${basePath}/${apiVersion}/busca-ita/${id_simulation}`;
  const refreshToken = getRefreshTokenApi();
  var status;
  var urlFetch='';
  var messag='';
  const params = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
      refreshToken: "Bearer " + refreshToken,
        functionname:'downloadFilefromIta',
        ippublica:getPublicIP()
    },
  };

  
  return fetch(url, params)
    .then((response) => {
      status=response.status;
    urlFetch=response.url;
    urlFetch=urlFetch.replace(`${basePath}/${apiVersion}/`,'')
      return response.json();
    })
    .then(async (result) => {
      if(status===202){
        messag=result.message
        notification["error"]({
          message: `Error ${status} in function: ${urlFetch}`,
          description:messag
        });
        getContarError(urlFetch,messag);
      }else if(status!==200){
          messag=result.message
          notification["error"]({
            message: `Error ${status} in function: ${urlFetch}`,
            description:messag
          });
          getContarError(urlFetch,messag);
      }else{
        notification["success"]({
          message: `Results updated!`,
        });
      }
     //console.log('OUT')
      return result;
    })
    .catch((err) => {
      return err.message;
    });
}

export  function getExcel(isExample,isful,isRoute,isRouteRaw ) {
  const url = `${basePath}/${apiVersion}/get-excel`;
  const bodyObj = {
    isExample: isExample,
    isful: isful,
    isRoute: isRoute,
    isRouteRaw: isRouteRaw,
  };
    
  var status;
  var urlFetch='';
  //console.log(url);
  const params = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + getAccessTokenApi(),
    refreshToken: "Bearer " + getRefreshTokenApi(),
    functionname:'getExcel',
    ippublica:getPublicIP()
    },
    body: JSON.stringify(bodyObj),
  };

  return fetch(url, params)
    .then((response) => {
      status=response.status;
      urlFetch=response.url;
      urlFetch=urlFetch.replace(`${basePath}/${apiVersion}/`,'')
      return response.blob()})
    .then((blobby) => {
      if(status!==200){
        notification["error"]({
          message: `Error ${status} in function: ${urlFetch}`,
        });
        getContarError(urlFetch,`Error ${status} in function: ${urlFetch}`);
      }
      let anchor = document.createElement("a");
      document.body.appendChild(anchor);
      let objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      if(isRoute){
        if(isRouteRaw){
          anchor.download = 'routes_raw.xlsx';
        }else{
          anchor.download = 'routes.xlsx';
        }
      }else{
        if(isExample){
          if(isful){
            anchor.download = 'exampleFull.xlsx';
          }else{
            anchor.download = 'example.xlsx';
          }
        }else{
          if(isful){
            anchor.download = 'basicFull.xlsx';
          }else{
            anchor.download = 'basic.xlsx';
          }
        }
      }
     
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    })
    .catch((err) => {
      console.log(err)
      return err.message;
    });
}

